import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from "@angular/common/http";

import { environment } from '../../environments/environment';

@Injectable()
export class IntegrationService {

  oracleEnabled: any = false;
  sharepointEnabled: any = false;
  salesforceEnabled: any  = false;
  oracleKnowlegeEnabled: any = false;
  drupalEnabled: any = false;
  aemEnabled: any = false;

  constructor(private _http: HttpClient) { }


  getAllIntegrationStatus(params) { 
    let url = environment.va_service_api + "integration/" + params.bot_id + "/all"
    return this._http.get(url)
  }

  getLiveAgentConfig(params) { 
    let url = environment.va_service_api + "integration/" + params.bot_id + "/get_config/" + params.channel + "/" + params.integrationModule
    return this._http.get(url)
  }
  getIntegrationStatus(params) { 
    let url = environment.va_service_api + "integration/" + params.bot_id + "/get_status/" + params.channel + "/" + params.integrationModule
    return this._http.get(url)
  }

  updateTakeoverConfig(params) {
    let url = environment.va_service_api + "integration/" + params.Bot_Id + "/updateconfig/" + params.channel + "/" + params.integrationModule
    return this._http.post(url, params)
  }

  configurePlugin(params) {
    let url = environment.va_service_api + "integration/" + params.Bot_Id + "/configureplugin/" + params.channel + "/" + params.integrationModule
    return this._http.post(url, params)
  }
  getLiveAgentSetting(params) { 
    let url = environment.va_service_api + "integration/" + params.bot_id + "/live_agent/setting/"
    return this._http.get(url)
  }
  getQueList(params) { 
    let url = environment.va_service_api + "integration/" + params.bot_id + "/get_que"
    return this._http.get(url)
  }
  createLiveAgentSetting(params, data) { 
    let url = environment.va_service_api + "integration/" + params.bot_id + "/live_agent/setting/create"
    return this._http.post(url, data)
  }
  deleteCreatedQue(params, queId) {
    return this._http.delete(environment.va_service_api + "integration/" + params.bot_id +  '/live_agent/setting/' + queId)
  }
  updateLiveAgentSetting(params, data){
    return this._http.put(environment.va_service_api + "integration/" + params.bot_id +  '/live_agent/setting/' + data.que_id, data)
  }
  searchLiveAgentSetting(agentId, params){ 
    return this._http.post(environment.va_service_api + "integration/" + agentId + "/live_agent/setting/search", params)
  }

  getMeetingAssistantCategoryList(agentId, params) {
    return this._http.get(environment.va_service_api + "integration/" + agentId + "/list_ma_category?org_id=" + params.org_id)
  }

  createNewMeetingAssistantCategory(agentId, params) {
    return this._http.post(environment.va_service_api + "integration/" + agentId + "/create_ma_category", params)
  }

  deleteCategory(agentId, categoryId) {
    return this._http.delete(environment.va_service_api + "integration/" + agentId + "/delete_ma_category/" + categoryId)
  }

  updateCategory(agentId, params, categoryId) {
    return this._http.put(environment.va_service_api + "integration/" + agentId + "/update_ma_category/" + categoryId, params)
  }

  getOrganisationList(params) {
    return this._http.post(environment.analytics_api + '/ma/get_org_id', params).pipe(
      map((response: Response) => {
        return response
      },
        (err: Response) => {
          return err
        })
    )
  }
    
}